/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.fskLocation', [])
    .factory('fskLocationService', FskLocationService)
    .name;

/*@ngInject*/
function FskLocationService($http, $q) {

    var service = {
        getFskLocations: getFskLocations,
        getFskLocation: getFskLocation,
        saveFskLocation: saveFskLocation,
        deleteFskLocation: deleteFskLocation
    };

    return service;

    function getFskLocations () {
        var deferred = $q.defer();
        $http.get('/api/fskLocations', { ignoreErrors: true }).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getFskLocation (fskLocationId) {
        var deferred = $q.defer();
        $http.get('/api/fskLocation/' + fskLocationId, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveFskLocation (fskLocation) {
        var deferred = $q.defer();
        $http.post('/api/fskLocation', fskLocation).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteFskLocation (fskLocationId) {
        var deferred = $q.defer();
        $http.delete('/api/fskLocation/' + fskLocationId).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/fsk-location.service.js